import { styled } from 'styled-components';

import { UncontrolledSearchQueryInputContainer } from '#/containers/UncontrolledSearchQueryInputContainer';
import { useI18n } from '#/i18n/hooks/useI18n';
import { getPopularSearchesBySearchType } from '#/modules/search/mappings/getPopularSearchesBySearchType';

import { usePageHeaderSearchInputsDesktopContext } from './DesktopSearchBarContext';

const Holder = styled.div`
  flex: 2;
`;

type Props = {
  initialQuery: string;
  searchOnClear: boolean;
  hidePopularSearches?: boolean;
};

export function DesktopSearchBarQueryInput({
  initialQuery,
  searchOnClear,
  hidePopularSearches,
}: Props) {
  const { i18n } = useI18n();

  const { submit, searchTypeForPopularSearches } =
    usePageHeaderSearchInputsDesktopContext();

  const popularSearches = getPopularSearchesBySearchType(
    i18n,
    searchTypeForPopularSearches,
  );

  return (
    <Holder>
      <UncontrolledSearchQueryInputContainer
        initialQuery={initialQuery}
        placeholder={i18n('Search by keyword, skill, or interest')}
        onClearQuery={
          searchOnClear
            ? () => submit({ triggeredByRemoteLocationChange: false })
            : undefined
        }
        presentation="contrast"
        id="search-query"
        qaId="search-input"
        popularSearches={!hidePopularSearches ? popularSearches : undefined}
        searchType={searchTypeForPopularSearches}
      />
    </Holder>
  );
}
